var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrandmaHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29377",
    "data-name": "Group 29377",
    transform: "translate(-288 -182.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(288 182.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28924",
    "data-name": "Group 28924",
    transform: "translate(307 187.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49959",
    "data-name": "Path 49959",
    d: "M187.151,5.688a3.177,3.177,0,0,0-3.177,3.177h6.354A3.177,3.177,0,0,0,187.151,5.688Z",
    transform: "translate(-180.079 -5.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49960",
    "data-name": "Path 49960",
    d: "M187.669,5.731a3.176,3.176,0,0,0-3.695,3.134h1.035A3.177,3.177,0,0,1,187.669,5.731Z",
    transform: "translate(-180.079 -5.688)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49961",
    "data-name": "Path 49961",
    d: "M133.086,38.059a6.589,6.589,0,0,0-5.99,0,3.151,3.151,0,0,0-.137.531l-.045.53h6.268v-.733A3.154,3.154,0,0,0,133.086,38.059Zm2.259,20.085a.553.553,0,0,0,.557-.546v-.006a5.81,5.81,0,0,0-11.62,0V57.6a.553.553,0,0,0,.557.546Z",
    transform: "translate(-123.019 -35.943)",
    fill: "#f8404a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49962",
    "data-name": "Path 49962",
    d: "M125.472,371.318v-.006a5.79,5.79,0,0,1,5.215-5.746,5.916,5.916,0,0,0-.6-.03,5.793,5.793,0,0,0-5.81,5.776v.006a.553.553,0,0,0,.557.546h1.191A.553.553,0,0,1,125.472,371.318Z",
    transform: "translate(-123.019 -349.663)",
    fill: "#b6333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49963",
    "data-name": "Path 49963",
    d: "M121.869,66.49c.529-3.725-.632-5.722-2.088-6.792a7.961,7.961,0,0,0-4.265-1.21,5.553,5.553,0,0,0-4.049,1.368,2.818,2.818,0,0,0-.4.429c-2.907,1.567-1.928,5.22-1.635,6.116v1.063h12.393Z",
    transform: "translate(-108.444 -56.157)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49964",
    "data-name": "Path 49964",
    d: "M112.211,60.286a2.818,2.818,0,0,1,.4-.429A5.377,5.377,0,0,1,116.02,58.5c-.315-.02-.5-.013-.5-.013a5.553,5.553,0,0,0-4.049,1.368,2.818,2.818,0,0,0-.4.429c-2.907,1.567-1.928,5.22-1.635,6.116v1.063h1.147V66.4C110.283,65.506,109.3,61.853,112.211,60.286Z",
    transform: "translate(-108.444 -56.157)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49965",
    "data-name": "Path 49965",
    d: "M371.17,239.359a1.17,1.17,0,0,0-1.15.463l.032,2.1a1.012,1.012,0,0,0,.479.259,1.477,1.477,0,0,0,.639-2.826Z",
    transform: "translate(-357.918 -229.029)",
    fill: "#ffc073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49966",
    "data-name": "Path 49966",
    d: "M96.557,240.359a1.477,1.477,0,0,0,.639,2.826,1.012,1.012,0,0,0,.479-.259l.032-2.1A1.169,1.169,0,0,0,96.557,240.359Z",
    transform: "translate(-95.672 -229.985)",
    fill: "#ffd7a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49967",
    "data-name": "Path 49967",
    d: "M96.245,242.035a1.347,1.347,0,0,1,.794-1.66,1.008,1.008,0,0,0-.483-.012,1.477,1.477,0,0,0,.639,2.826l.046-.012A1.489,1.489,0,0,1,96.245,242.035Z",
    transform: "translate(-95.672 -229.989)",
    fill: "#ffc073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49968",
    "data-name": "Path 49968",
    d: "M145.147,168.477a42.228,42.228,0,0,0-.141,5.3,1.5,1.5,0,0,0,2.553.022.17.17,0,0,0-.136-.269Zm6.023-.5a7.017,7.017,0,0,1-2.962-3.551c-2.356,2.75-6.8,3.551-6.8,3.551s-1.638,5.314,4.879,5.36C152.808,173.287,151.17,167.974,151.17,167.974Z",
    transform: "translate(-139.219 -157.421)",
    fill: "#ffd7a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49969",
    "data-name": "Path 49969",
    d: "M147.172,246.275c-6.517-.047-4.879-5.36-4.879-5.36l-.882.176s-1.638,5.314,4.879,5.36a8.453,8.453,0,0,0,2.15-.262A9.874,9.874,0,0,1,147.172,246.275Zm-1.67.356-.295,0a.2.2,0,0,0-.162.322,1.583,1.583,0,0,0,1.244.672,1.365,1.365,0,0,0,.331-.041A1.813,1.813,0,0,1,145.5,246.632Z",
    transform: "translate(-139.218 -230.539)",
    fill: "#ffc073"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28921",
    "data-name": "Group 28921",
    transform: "translate(3.017 11.934)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_426",
    "data-name": "Ellipse 426",
    cx: 0.862,
    cy: 0.857,
    rx: 0.862,
    ry: 0.857,
    fill: "#fdac7c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    cx: 0.862,
    cy: 0.857,
    rx: 0.862,
    ry: 0.857,
    transform: "translate(6.388)",
    fill: "#fdac7c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49970",
    "data-name": "Path 49970",
    d: "M187.264,42.223a5.224,5.224,0,0,0-1.266.5,3.157,3.157,0,0,0-.1.332v.606a4.893,4.893,0,0,1,1-.455A3.153,3.153,0,0,1,187.264,42.223Z",
    transform: "translate(-181.921 -40.611)",
    fill: "#b6333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49971",
    "data-name": "Path 49971",
    d: "M233.341,304.335a.132.132,0,0,0-.132.132c0,.172-.353.365-.825.365s-.825-.193-.825-.365a.132.132,0,0,0-.265,0c0,.359.468.63,1.09.63s1.09-.271,1.09-.63A.132.132,0,0,0,233.341,304.335Z",
    transform: "translate(-225.312 -291.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49973",
    "data-name": "Path 49973",
    d: "M179.714,227.446a.488.488,0,0,1,.651,0,.132.132,0,1,0,.176-.2.753.753,0,0,0-1,0,.132.132,0,1,0,.176.2Zm-5.7,1.239a.176.176,0,1,0,.254.245c.624-.649,1.74.249,1.751.258a.176.176,0,0,0,.224-.273C176.19,228.869,174.867,227.8,174.017,228.685Zm4.91.23a.176.176,0,0,0,.224.273c.011-.009,1.126-.907,1.751-.258a.176.176,0,0,0,.254-.245C180.3,227.8,178.982,228.869,178.927,228.915Zm-2.887.894c-.035.035-.856.872-.578,1.623a.132.132,0,0,0,.248-.092c-.22-.592.51-1.337.517-1.345a.132.132,0,0,0-.188-.187Z",
    transform: "translate(-170.514 -217.292)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandmaHighlighted);
export default __webpack_public_path__ + "static/media/GrandmaHighlighted.068522e1109b50da5de754d5f65a84a8.svg";
export { ForwardRef as ReactComponent };